import { createRoutine } from 'redux-saga-routines';
import {
  GET_COMPANY_DATA,
  GET_COMPANY_SEASONS_VALUES,
  GET_COMPANY_VENUES,
  GET_COMPANY_UNPUBLISHED_SEASON,
  GET_COMPANY_CONTACT,
  ADD_AND_UPDATE_CONTACTS,
  UPDATE_COMPANY,
  SET_COMPANY,
  GET_MUSICAL_WORKS_LIST,
  GET_COMPANY_EDIT_SEASON,
  GET_COMPANY_IMAGES,
  GET_COMPANY_VIDEOS,
  SET_SEASONS,
  CLEAR_EDIT_SEASONS,
  GET_COMPANY_STAFF,
  UPDATE_COMPANY_INFO,
  UPDATE_COMPANY_VENUE,
  GET_COMPANY_DESCRIPTIONS,
  CREATE_COMPANY_DESCRIPTION,
  UPDATE_COMPANY_DESCRIPTION,
  DELETE_COMPANY_DESCRIPTION,
} from './constants';

export const getCompanyDataAction = createRoutine(GET_COMPANY_DATA);
export const getCompanyContactAction = createRoutine(GET_COMPANY_CONTACT);
export const getCompanyEditSeasonAction = createRoutine(GET_COMPANY_EDIT_SEASON);
export const getCompanyUnpublishedSeasonAction = createRoutine(GET_COMPANY_UNPUBLISHED_SEASON);
export const getCompanySeasonsValueAction = createRoutine(GET_COMPANY_SEASONS_VALUES);
export const getCompanyVenuesAction = createRoutine(GET_COMPANY_VENUES);
export const addAndUpdateContactsAction = createRoutine(ADD_AND_UPDATE_CONTACTS);
export const updateCompanyAction = createRoutine(UPDATE_COMPANY);
export const getMusicalWorksListAction = createRoutine(GET_MUSICAL_WORKS_LIST);
export const getCompanyImagesAction = createRoutine(GET_COMPANY_IMAGES);
export const getCompanyVideosAction = createRoutine(GET_COMPANY_VIDEOS);
export const getCompanyStaffAction = createRoutine(GET_COMPANY_STAFF);
export const updateCompanyInfoAction = createRoutine(UPDATE_COMPANY_INFO);
export const updateCompanyVenueAction = createRoutine(UPDATE_COMPANY_VENUE);
export const getCompanyDescriptionsAction = createRoutine(GET_COMPANY_DESCRIPTIONS);
export const createCompanyDescriptionAction = createRoutine(CREATE_COMPANY_DESCRIPTION);
export const updateCompanyDescriptionAction = createRoutine(UPDATE_COMPANY_DESCRIPTION);
export const deleteCompanyDescriptionAction = createRoutine(DELETE_COMPANY_DESCRIPTION);

export const setCompany = company => ({
  type: SET_COMPANY,
  payload: company,
});

export function setCompanySeasons(seasons) {
  return {
    type: SET_SEASONS,
    payload: { seasons },
  };
}

export function clearCompanyEditSeason() {
  return {
    type: CLEAR_EDIT_SEASONS,
    payload: [],
  };
}
